export default {
  edit_note: 'Opmerking bewerken',
  add_note: 'Opmerking toevoegen ',
  update: 'Item bijwerken',
  feedback: {
    item_sold_out_one: 'Het spijt ons, maar we hebben momenteel geen {{items}} meer.',
    item_sold_out_other: 'Het spijt ons, maar we hebben momenteel geen {{items}} meer.',
    item_unavailable:
      'Dit item is alleen beschikbaar vanaf {{schedule}}. Wijzig de besteltijd of verwijder het item om te bestellen.',
  },
  buttons: {
    update: 'Bijwerken',
  },
};
